import type { ComponentProps, HTMLAttributes } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { DisplayProps, SizeProps } from 'styled-system';
import { display, size } from 'styled-system';

import type {
  FilterProps,
  ObjectFitProps,
  OutlineColorProps,
  TransitionProps,
} from '../../theme/system-utilities';
import { filter, objectFit, outlineColor, transition } from '../../theme/system-utilities';
import { createLazyLoadingAttribute } from '../../utils/image';
import { getYouTubeImageUrl, YouTubeThumbnailQuality as Quality } from '../../utils/youtube';
import IconPlay from './IconPlay';

interface FacadeProps extends HTMLAttributes<HTMLImageElement> {
  alt: string;
  videoId: string;
  isLazy: boolean;
}

const UnstyledImage = styled.img<
  DisplayProps & SizeProps & ObjectFitProps & TransitionProps & FilterProps & OutlineColorProps
>`
  ${display};
  ${size};
  ${objectFit};
  ${transition};
  ${filter};
  ${outlineColor};
`;

const Image = (props: ComponentProps<typeof UnstyledImage>) => (
  <UnstyledImage
    display="block"
    size="100%"
    objectFit="contain"
    transition="opacity filter 0.3s ease-in-out"
    filter="blur(4px)"
    outlineColor="sys.secondary.border.focus"
    {...props}
  />
);

const Facade = ({ videoId, alt, isLazy, ...props }: FacadeProps) => (
  <>
    <IconPlay />
    <Image
      {...props}
      {...createLazyLoadingAttribute(isLazy)}
      src={getYouTubeImageUrl(videoId, Quality.HQDefault)}
      alt={alt}
    />
  </>
);

export default Facade;
